import { Flex, List, ListIcon, ListItem, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

import { CircleIcon } from '../../../../shared/ui/icons';
import { CopyButton } from './SummaryPrimitives';

export type ConfigSummaryDetail = {
  label?: string;
  value: ReactNode | string;
  copyValue?: string;
};

export const ConfigSummaryList = ({
  details,
}: {
  details: ConfigSummaryDetail[];
}) => (
  <List mt="2" pl="10" spacing={3}>
    {details.map((config, i) => (
      <ListItem
        key={`${config.label}-${i}`}
        display="flex"
        alignItems="flex-end"
        justifyContent="space-between"
        _hover={{
          '.copy-button': {
            visibility: 'visible',
          },
        }}
      >
        <Flex alignItems="flex-start">
          <ListIcon as={CircleIcon} color="green.500" boxSize="2" mt="5px" />
          <Text color="text.primary" fontSize="xs">
            {config.label ? (
              <>
                <Text as="b">{config.label}</Text>: {config.value}
              </>
            ) : (
              config.value
            )}
          </Text>
        </Flex>
        {config.copyValue ? <CopyButton value={config.copyValue} /> : null}
      </ListItem>
    ))}
  </List>
);
